import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import React from 'react'
import { generateRandomGuiID } from '../../utils/commonUtils'
import { TokTokDocSelectOption, TokTokDocSelectProps } from './_props/TokTokDocSelectProps'

 const TokTokDocSelect: React.FC<TokTokDocSelectProps> = ( {
    className,
    id,
    name,
    onChange,
    value,
    error,
    options,
    label,
    disabled,
}) => 
     (
        <TextField
            variant="outlined"
            autoComplete="none"
            select
            className={className}
            id={id}
            label={label}
            name={name}
            onChange={onChange}
            value={value}
            error={error}
            disabled={disabled}
        >
            {options.map((option: TokTokDocSelectOption) => (
                <MenuItem key={generateRandomGuiID()} value={option.value}>
                    {option.label}
                </MenuItem>
            ))}
        </TextField>
    )

export default TokTokDocSelect